<template>
  <FormControl :label="label" :required="required" @disabled="onSetDisabled">
    <input type="radio" ref="input" class="form-check-input" @change="onChange" :name="name" v-model="model[modelAttribute || name]" :value="value" :disabled="getIsDisabled() && value != getValue()">
  </FormControl>
</template>

<script>
  import FormControl from './FormControl';
  import formControlMixin from './mixins/form-control.mixin.js';

  export default {
    name: 'radio-button',
    props: ['required', 'label', 'model', 'name', 'modelAttribute', 'value', 'disabled'],
    components: {
      FormControl
    },
    mixins: [formControlMixin],
    methods: {
      onChange() {
        this.$emit('change', this.model[this.modelAttribute || this.name]);
      },
      onSpace(option) {
        this.model[this.modelAttribute || this.name] = option.value
        this.$forceUpdate();
      }
    }
  }
</script>
